import { categoryLifecycleTopic, TagCategory } from 'apprise-core/category'
import { LifecycleEvent } from 'apprise-core/common'
import { EventSubscription } from "apprise-frontend-events/subscriptions"
import { useCurrentLocation } from 'apprise-ui/link/currentlocation'
import { useHistory } from 'react-router-dom'
import { useCategoryStore } from './store'
import { useTagStore } from 'apprise-frontend-tags/tag/store'




// supports first generation or second generation publishers.
export const useCategoryLifecycleListener = (): EventSubscription<LifecycleEvent<TagCategory>> => {

    const tags = useTagStore()
    const store = useCategoryStore()

    const location = useCurrentLocation()

    const history = useHistory()

    return {

        topic: categoryLifecycleTopic

        ,

        onEvent: (event: LifecycleEvent<TagCategory>) => {

            // updates local cache.
            store.push(event)

            // sends signal to subscribers mounted on impacted routes, so they can warn the user.
            history.replace(location.current(), `${event.subject.id}-${event.type}`)


            if (event.type === 'remove')
                setTimeout(() =>tags.removeTagsInCategory(event.subject.id), 1000)

        }

    }

}